import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

const faChallenge: IconDefinition = {
    icon: [
        36,
        36,
        [],
        'f140',
        [
            'M28.3564 12.6295C28.3564 18.1374 23.7197 22.6023 18 22.6023C12.2803 22.6023 7.64355 18.1374 7.64355 12.6295C7.64355 7.12171 12.2803 2.65674 18 2.65674C23.7197 2.65674 28.3564 7.12171 28.3564 12.6295Z',
            'M23.815 23.5366C24.3213 23.2758 24.9043 23.6593 24.9043 24.227V31.6683C24.9043 33.0491 23.9377 33.7242 22.741 33.1565L18.6291 31.208C18.2762 31.0546 17.7238 31.0546 17.3709 31.208L13.259 33.1565C12.0623 33.7089 11.0957 33.0338 11.0957 31.6529L11.1264 24.227C11.1264 23.6593 11.7248 23.2911 12.2157 23.5366C13.9495 24.4111 15.9134 24.9021 18 24.9021C20.0866 24.9021 22.0659 24.4111 23.815 23.5366Z',
        ],
    ],
    prefix: 'fas',
    iconName: '0',
};

export default faChallenge;
